import React from 'react'
import styled from 'styled-components'

const FallbackContainer = styled.div`
  background-color: var(--sn-stylekit-background-color);
  border: 1px solid var(--sn-stylekit-danger-color);
  border-radius: 8px;
  box-sizing: border-box;
  margin: 16px;
  padding: 16px;
  color: var(--sn-stylekit-danger-color);
`

const ErrorMessage = styled.pre`
  margin-top: 12px;
  font-size: 12px;
  overflow-x: auto;
  color: var(--sn-stylekit-foreground-color);
`

export const ErrorBoundaryFallback = ({ error }: { error: Error }) => {
  return (
    <FallbackContainer>
      <h3>Something went wrong</h3>
      <p>The SN Group Checklist extension encountered a critical error. Please reload the note.</p>
      <ErrorMessage>{error.message}</ErrorMessage>
    </FallbackContainer>
  )
}
